import styles from "@/styles/components/eyebrowLabel.module.scss";

interface Props {
    text: string;
    type?: string;
    backgroundColor?: string;
    textColor?: string;
}

export default function EyebrowLabel({text, type, backgroundColor = "", textColor = ""}: Props){

    function determineEyebrowLabelBackgroundColour(){
    
        if(type === "retail")
            return("rgba(247, 162, 133, 0.1)");

        else if(type === "transportation")
            return("rgba(97, 188, 142, 0.1)");

        else if(type === "industries")
            return("rgba(200, 145, 248, 0.1)");

        return("")
    }

    function determineEyebrowLabelTextColour(){

        if(type === "retail")
            return("rgba(247, 162, 133, 0.9)");

        else if(type === "transportation")
            return("rgba(97, 188, 142, 0.8)");

        else if(type === "industries")
            return("rgba(200, 145, 248, 0.8)");

        return("")
    }

    function getLightEffectClass(){
        if(type === "retail")
            return "light_effect_card_retail";
        else if(type === "transportation")
            return "light_effect_card_transport";
        else if(type === "industries")
            return "light_effect_card_industry";
        return "light_effect_card";
    }

    return(
        <div 
            className = {`${styles.rootDiv} ${getLightEffectClass()}`}
            style = {{
                backgroundColor: (backgroundColor === "" ? determineEyebrowLabelBackgroundColour() : backgroundColor),
                color: (textColor === "" ? determineEyebrowLabelTextColour() : textColor)
            }}>
            {text.toUpperCase()}
        </div>
    )
}